import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=1faa81f2&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=1faa81f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa81f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1faa81f2')) {
      api.createRecord('1faa81f2', component.options)
    } else {
      api.reload('1faa81f2', component.options)
    }
    module.hot.accept("./GoodsDetail.vue?vue&type=template&id=1faa81f2&scoped=true", function () {
      api.rerender('1faa81f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/steps/GoodsDetail.vue"
export default component.exports